<template>
  <v-select
    :value="value"
    @input="value => emit(value)"
    :label="config.label"
    :items="types"
    item-text="label"
    item-value="key"
    :required="config.required"
    :error="haveErrors()"
    :rules="config.errors"
    dark>
  </v-select>
</template>

<script>
  import input from '@/mixins/input'
  export default {
    mixins: [input],
    computed: {
      types () {
        return ['public', 'promotion', 'private']
          .map(x => ({ key: x, label: this.$t(`inputs.offertype.types.${x}`) }))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/inputs/OfferType.vue